import { Close, OpenInNew } from '@mui/icons-material'
import { Box, Button, IconButton, Stack, Typography } from '@mui/material'
import { buildCampaignLink } from 'src/features/campaignBanner/buildCampaignLink'
import { Campaign } from 'src/features/campaignBanner/parseCampaigns'

/** バナーの高さ（px） */
export const BANNER_HEIGHT = 56

type Props = {
  campaign: Campaign
  onClose: () => void
}

export const CampaignBanner = (props: Props) => {
  const { campaign, onClose } = props
  const { title, cta, backgroundColor, foregroundColor, imageUrl } = campaign

  return (
    <Stack
      component="section"
      aria-label="キャンペーンのお知らせ"
      direction="row"
      alignItems="center"
      spacing={2}
      // 画像は display で出し分けるため、非表示側の要素に margin が残らないよう gap で余白を取る
      useFlexGap
      sx={{
        height: `${BANNER_HEIGHT}px`,
        pr: 2,
        backgroundColor,
        color: foregroundColor,
      }}
    >
      <Box
        component="img"
        src={imageUrl.small}
        alt=""
        sx={{
          display: { xs: 'block', lg: 'none' },
          width: '160px',
          height: `${BANNER_HEIGHT}px`,
        }}
      />
      <Box
        component="img"
        src={imageUrl.large}
        alt=""
        sx={{
          display: { xs: 'none', lg: 'block' },
          width: '332px',
          height: `${BANNER_HEIGHT}px`,
        }}
      />

      <Typography
        sx={{
          flex: 1,
          minWidth: 0,
          typography: { xs: 'body1', lg: 'h5' },
          // body1 は 400 だが lg 未満では太字にする。h5 は 700 なので、結果的にどちらも 700 になる
          fontWeight: 'bold',
          // 1 行に収まらない場合は 2 行に折り返す。
          // バナーの高さは 56px 固定なので、2 行が収まるよう行間を詰め、3 行目以降は省略する。
          lineHeight: 1.25,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden',
        }}
      >
        {title}
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        component="a"
        href={buildCampaignLink(campaign)}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<OpenInNew />}
        sx={{ flexShrink: 0 }}
      >
        {cta}
      </Button>

      <IconButton
        size="medium"
        aria-label="バナーを閉じる"
        onClick={onClose}
        sx={{ color: 'inherit' }}
      >
        <Close />
      </IconButton>
    </Stack>
  )
}
